import { styled } from '@material-ui/core/styles';

const getPaddingTop = (isDesktop: boolean, isLoginPage: boolean) => {
  if (isLoginPage) return 0;
  return isDesktop ? 90 : 80;
};

export const StyledContainer = styled('div')(
  ({
    isDesktop,
    isLoginPage,
  }: {
    isDesktop: boolean;
    isLoginPage: boolean;
  }) => ({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    paddingTop: getPaddingTop(isDesktop, isLoginPage),
  }),
);
